import { Loader } from "../customplugins/loader.js";
import { Toaster } from "../customplugins/toaster.js";
const modalElement = document.getElementById('exampleModal');
const modal = new (window as any).bootstrap.Modal(modalElement);
const purchaseTypeModalelement = document.getElementById('purchaseTypeModal');
const purchaseTypeModal = new (window as any).bootstrap.Modal(purchaseTypeModalelement);
let qtyInput = document.getElementById("Qty") as HTMLInputElement;
import { ResponsiveCarousel } from "../customplugins/carousel.js";
let plusBtn = document.getElementById("Qty_plus");
let minusBtn = document.getElementById("Qty_minus");
let cartitemid=0
let cartDetaileditemid = 0
let packageid=0
document.addEventListener("DOMContentLoaded", () => {

    (window as any).addtocart = async function (type: number = 2, ProductId: any, ProductDetailId: any, package_id?: number, Qty?: number  ) {
        if (Qty === undefined) {
            const qtyElement = document.getElementById("Qty") as HTMLInputElement | null;
            Qty = parseInt(qtyElement?.value || "1");
        }
        cartDetaileditemid = ProductDetailId
        cartitemid = ProductId
        packageid = package_id??0
        // safety check
        if (!Qty || Qty < 1) Qty = 1;
        var obj = {
            "RegId": 0,
            "ProductId": ProductId,
            "ProductDetailId": ProductDetailId,
            "Quantity": Qty,
            "AddedBy": 0,
            "TenantId": 0,
            "Type": type==1?"ADD":"UPDATE",
            "package_id": package_id
        }
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        //console.log(obj);
        Loader.show(); 
        const res = await fetch("/ShoppingCart/AddCart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
            body: JSON.stringify(obj)
        });

        const result = await res.json();

       

        if (result?.status == false && result?.type =="Login") {
            Loader.hide();
            modal.show();
        }
        else if (result?.status == false && result?.type == "Purchase") {
            Loader.hide();
            purchaseTypeModal.show();
        }
        else {
            if (result?.success) {
                (document.getElementById("cartcount") as HTMLInputElement).textContent = result?.data.cartCount;
                //(window as any).updateHeader();
                cartDetaileditemid = 0;
                cartitemid = 0;
                packageid = 0;
                (window as any).updateCart();
            }
        }
    };
    (window as any).OpenPurchaseType = function (): void {
        purchaseTypeModal.show();
    };

    (window as any).login = async function (methodType: "PASSWORD" | "WITH_OTP" = "PASSWORD") {
        Loader.show();
        let obj = {
            "tenant_id": 0,
            "IPAddress": "",
            "SessionId": "",
            "memberid": (document.getElementById("memberid") as HTMLInputElement).value,
            "password": (document.getElementById("password") as HTMLInputElement).value,
            "login_type": (document.getElementById("login_type") as HTMLInputElement).value
        }
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const res = await fetch(`/LoginPopup?loginMethod=${methodType}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
            body: JSON.stringify(obj)
        });

        const result = await res.json();
        Loader.hide();
        if (result?.status == true) {
            if (result?.isfirstlogin) {
                const modalContent = document.querySelector(".modal-content.loginpopup") as HTMLElement;
                if (modalContent) {
                    modalContent.innerHTML = result.html;
                    loadPasswordValidationModule();
                }
            }
            else if (!result?.isfirstlogin && result?.isotplogin) {
                const modalContent = document.querySelector(".modal-content.loginpopup") as HTMLElement;
                if (modalContent) {
                    modalContent.innerHTML = result.html;
                    loadPasswordValidationModule();
                }
            }
            else {
                await (window as any).updateHeader();
                const loginqtyElement = document.getElementById("Qty") as HTMLInputElement | null;
                const loginqty = parseInt(loginqtyElement?.value || "1");
                (window as any).addtocart(1, cartitemid, cartDetaileditemid, packageid, loginqty);
                await (window as any).BestSellingProduct();
                await (window as any).ProductViewPartialView();
                await (window as any).RelatedProductsViewComponent();
                await (window as any).ProductsViewComponentRefresh();
                modal.hide();
            }
           
        } else {
            Toaster.error("User ID / Password Wrong");
        }
    };
    function loadPasswordValidationModule(): void {
        const scriptId = "firstLoginValidationScript";

        if (document.getElementById(scriptId)) return;

        const scriptElement = document.createElement("script");
        scriptElement.id = scriptId;
        scriptElement.type = "module";

        const cacheBusterToken = new Date().getTime();

        scriptElement.src = `/js/script/opensite/first-login-validation.js?v=${cacheBusterToken}`;
        document.body.appendChild(scriptElement);
    }


    (window as any).Sumbitrepurchase = async function () {
        const purchaseTypeElement = document.getElementById(
            "purchaseType"
        ) as HTMLSelectElement | null;

        if (!purchaseTypeElement || !purchaseTypeElement.value) {
            Toaster.error("Please select a Purchase Type");
            return;
        }

        Loader.show();

        try {
            const obj = {
                Purchase_Type_id: parseInt(purchaseTypeElement.value, 10)
            };

            const input = document.querySelector(
                'input[name="__RequestVerificationToken"]'
            ) as HTMLInputElement | null;

            const headers: Record<string, string> = {
                "Content-Type": "application/json"
            };

            if (input) {
                headers["RequestVerificationToken"] = input.value;
            }

            const res = await fetch("/ShoppingCart/SubmitRepurchase", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(obj)
            });

            const result = await res.json();

            if (result?.status === true) {
                //Toaster.success("Purchase Type saved successfully");
                await (window as any).updateHeader();
                const loginqtyElement = document.getElementById("Qty") as HTMLInputElement | null;
                const loginqty = parseInt(loginqtyElement?.value || "1");
                (window as any).addtocart(1, cartitemid, cartDetaileditemid, packageid, loginqty);
                await (window as any).BestSellingProduct();
                await (window as any).ProductViewPartialView();
                await (window as any).RelatedProductsViewComponent();
                await (window as any).ProductsViewComponentRefresh();
                const modalElement = document.getElementById("purchaseTypeModal");
                if (modalElement) {
                    const modal = bootstrap.Modal.getInstance(modalElement);
                    modal?.hide();
                }
              
                // Refresh any required UI components here.
            } else {
                Toaster.error(result?.message || "Unable to save Purchase Type");
            }
        } catch (error) {
            console.error("SubmitRepurchase error:", error);
            Toaster.error("Something went wrong. Please try again.");
        } finally {
            Loader.hide();
        }
    };


    (window as any).SumbitrepurchaseNew = async function (purchaseTypeId: string) {
        //const purchaseTypeElement = document.getElementById(
        //    "purchaseType"
        //) as HTMLSelectElement | null;

        //if (!purchaseTypeElement || !purchaseTypeElement.value) {
        //    Toaster.error("Please select a Purchase Type");
        //    return;
        //}

        Loader.show();

        try {
            const obj = {
                Purchase_Type_id: parseInt(purchaseTypeId, 10)
            };

            const input = document.querySelector(
                'input[name="__RequestVerificationToken"]'
            ) as HTMLInputElement | null;

            const headers: Record<string, string> = {
                "Content-Type": "application/json"
            };

            if (input) {
                headers["RequestVerificationToken"] = input.value;
            }

            const res = await fetch("/ShoppingCart/SubmitRepurchase", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(obj)
            });

            const result = await res.json();

            if (result?.status === true) {
                //Toaster.success("Purchase Type saved successfully");
                await (window as any).updateHeader();
                const loginqtyElement = document.getElementById("Qty") as HTMLInputElement | null;
                const loginqty = parseInt(loginqtyElement?.value || "1");
                (window as any).addtocart(1, cartitemid, cartDetaileditemid, packageid, loginqty);
                await (window as any).BestSellingProduct();
                await (window as any).ProductViewPartialView();
                await (window as any).RelatedProductsViewComponent();
                await (window as any).ProductsViewComponentRefresh();
                const modalElement = document.getElementById("purchaseTypeModal");
                if (modalElement) {
                    const modal = bootstrap.Modal.getInstance(modalElement);
                    modal?.hide();
                }

                // Refresh any required UI components here.
            } else {
                Toaster.error(result?.message || "Unable to save Purchase Type");
            }
        } catch (error) {
            console.error("SubmitRepurchase error:", error);
            Toaster.error("Something went wrong. Please try again.");
        } finally {
            Loader.hide();
        }
    };













    (window as any).Customerlogin = async function () {
        Loader.show();
        let obj = {
            "tenant_id": 0,
            "IPAddress": "",
            "SessionId": "",
            "memberid": (document.getElementById("memberid") as HTMLInputElement).value,
            "password": (document.getElementById("password") as HTMLInputElement).value
        }
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const res = await fetch("/LoginPopupCustomer", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
            body: JSON.stringify(obj)
        });

        const result = await res.json();
        Loader.hide();

        if (result?.status == true) {
            await (window as any).updateHeader();
            const loginqtyElement = document.getElementById("Qty") as HTMLInputElement | null;
            const loginqty = parseInt(loginqtyElement?.value || "1");
            (window as any).addtocart(1, cartitemid, cartDetaileditemid, packageid, loginqty);
            await (window as any).BestSellingProduct();
            await (window as any).ProductViewPartialView();
            await (window as any).RelatedProductsViewComponent();
            await (window as any).ProductsViewComponentRefresh();
            modal.hide();

        } else {
            Toaster.error("User ID / Password Wrong");
        }
    };
    if (qtyInput) {
        qtyInput.value = "1";
    }

    // ➕ Increase
    plusBtn?.addEventListener("click", () => {
        let value = parseInt(qtyInput.value) || 0;
        qtyInput.value = (value + 1).toString();
    });

    // ➖ Decrease
    minusBtn?.addEventListener("click", () => {
        let value = parseInt(qtyInput.value) || 0;

        if (value > 1) {
            qtyInput.value = (value - 1).toString();
        }
    });

    (window as any).changeQty = async function (el: HTMLElement, step: number, ProductId: any, ProductDetailId: any, package_id :any) {

        const parent = el.closest(".qty-stepper");

        if (!parent) return;

        // find qty display div
        const qtyInput = parent.querySelector(".qty-val") as HTMLInputElement | null;

        if (!qtyInput) return;

        // get current value
        let currentQty = parseInt(qtyInput.value || "1");

        // update qty
        currentQty += step;

        // prevent negative or zero (optional)
        if (currentQty < 1) currentQty = 1;

        // set updated value
        qtyInput.value = currentQty.toString();

        (window as any).addtocart(2, ProductId, ProductDetailId, package_id, currentQty);

        //(window as any).updateCart();
    }

    const UpdateqtyInput = document.getElementById("qtyinput") as HTMLInputElement;

    if (UpdateqtyInput) {

        UpdateqtyInput.addEventListener("keydown", (e: KeyboardEvent) => {
            const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab"
            ];

            if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                e.preventDefault();
            }
        });

        UpdateqtyInput.addEventListener("input", () => {
            UpdateqtyInput.value = UpdateqtyInput.value.replace(/[^0-9]/g, '');

            if (UpdateqtyInput.value.startsWith('0')) {
                UpdateqtyInput.value = UpdateqtyInput.value.replace(/^0+/, '');
            }

            if (UpdateqtyInput.value === '') {
                UpdateqtyInput.value = '1';
            }
        });
    }

});

(window as any).updateQty = async function (
    input: HTMLInputElement,
    ProductId: any,
    ProductDetailId: any,
    package_id:any
) {
    let qty = parseInt(input.value || "1");

    if (qty < 1) qty = 1;

    input.value = qty.toString();

    await (window as any).addtocart(
        2,
        ProductId,
        ProductDetailId, package_id,
        qty
    );
};
(window as any).DeleteCart = async function (CartId: any, package_id:any) {
    Loader.show();
    let obj = {
        "tenant_id": 0,
        "RegId": 0,
        "CartId": CartId,
        "package_id": package_id
    }
    const input = document.querySelector(
        'input[name="__RequestVerificationToken"]'
    ) as HTMLInputElement;
    const res = await fetch("/ShoppingCart/DeleteCartByRegid", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "RequestVerificationToken": input.value
        },
        body: JSON.stringify(obj)
    });

    const result = await res.json();
    console.log(result);
    (document.getElementById("cartcount") as HTMLInputElement).textContent = result?.cartCount;

    (window as any).updateCart();
    Loader.hide();
 

};

(window as any).updateCart = async function () {

    if (document.getElementById("cartpage")) {
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const res = await fetch("/ShoppingCart/CartViewComponent", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
        });
        const result = await res.text();
    
        document.getElementById("cartpage")!.innerHTML = result;
    }
    Loader.hide();
};

(window as any).updateCart = async function () {

    if (document.getElementById("cartpage")) {
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const res = await fetch("/ShoppingCart/CartViewComponent", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
        });
        const result = await res.text();

        document.getElementById("cartpage")!.innerHTML = result;
    }
    Loader.hide();
};

(window as any).BestSellingProduct = async function () {

    if (document.getElementById("BestSellingProducts")) {
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const res = await fetch("/BestSellingProducts", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": input.value
            },
        });
        const result = await res.text();

        document.getElementById("BestSellingProducts")!.innerHTML = result;
        //new ResponsiveCarousel("bestsellers", {
        //    loop: false,
        //    margin: 10,
        //    nav: true,
        //    responsive: {
        //        0: { items: 1 },
        //        600: { items: 3 },
        //        1000: { items: 4 }
        //    }
        //});
    }
    Loader.hide();
};

(window as any).ProductViewPartialView = async function () {
  

    if (document.getElementById("productDetailsView")) {
        const input = document.querySelector(
            'input[name="__RequestVerificationToken"]'
        ) as HTMLInputElement;
        const pathParts = window.location.pathname.split('/');
        const productId = pathParts[pathParts.length - 1];
        const res = await fetch(`/ProductViewPartialView?ProductId=${productId}`, {
            method: "GET"
        });
        const result = await res.text();
        document.getElementById("productDetailsView").innerHTML = result;
    }
    Loader.hide();
};
(window as any).RelatedProductsViewComponent = async function () {


    if (document.getElementById("RelatedProductsDiv")) {
        const pathParts = window.location.pathname.split('/');
        const productId = pathParts[pathParts.length - 1];
        const res = await fetch(`/RelatedProductsViewcomponet?ProductId=${productId}`, {
            method: "GET"
        });
        const result = await res.text();
        document.getElementById("RelatedProductsDiv").innerHTML = result;
    }
    Loader.hide();
};
(window as any).ProductsViewComponentRefresh = async function () {

    if (document.getElementById("ProductView")) {

        var jsondata = JSON.stringify({})

        const res = await fetch(`/Products/GetProductsViewComponent`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Filters: jsondata, PageNumber: 1, RowCount: 12, ispackage: packageid>0 ?1:0 })
        });

        const result = await res.text();
        document.getElementById("ProductView").innerHTML = result;
    }

    Loader.hide();
};